import React from 'react'
import HeaderOne from '../../common/header/HeaderOne'
import CustomFooter from "../../elements/CustomFooter/CustomFooter";
import Copyright from '../../common/footer/Copyright'
import './style.css'
import SEO from '../../common/SEO';

function AngularJSDevelopment() {
  return (
    <>
      <SEO title="About Us" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent66" />
        <div className="slider-area slider-style-1 height-380 bg_image" data-black-overlay="1" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/banner/wordpressdev.jpg)` }}>
        </div>


        <div className='main_container_for_services'>
          <div className='inner_container_for_services'>
            <div style={{ height: '8px', width: '60px', background: '#00C896', marginBottom: '2rem' }}></div>            <h1>AngularJS <br />Development</h1>
            <p style={{ marginBottom: '3.5rem' }}>Build beautiful, more powerful, more engaging apps, and get them to market quicker - that's the power of AngularJS.</p>
            <p style={{ marginBottom: '3.5rem' }}>Developers and users alike love the feature-rich usability that comes from web apps built with AngularJS. Maintained by Google, AngularJS is an open-source, flexible, JavaScript-based framework, which allows for the creation of highly responsive, dynamic web applications, with less coding required.</p>
            <h3>Advantages of Developing Apps in AngularJS</h3>
            <p style={{ marginBottom: '3.5rem' }}>Working with AngularJS allows our developers to create dynamic, multi-functional web apps in less time, using less code. Such advantages mean;</p>
            <ul style={{ listStyleType: 'square' }}>
              <li>MVC structure makes it fast and easy to create dynamic web apps.</li>
              <li>AngularJS offers a feature-rich framework and simplistic functionalities with less coding required.</li>
              <li>A declarative HTML user interface significantly simplifies and expedites the development process.</li>
              <li>Two-way data binding synchronizes the data between the view and model eliminating the need for extra code.</li>
              <li>Reusable and customizable features allow our team to create web apps that are specifically tailored to your unique needs but remain quick to deploy, easy to scale, and cost-effective.</li>
            </ul>
            <h3>Why clients choose YGS Web Solutions as their trusted AngularJS development specialists.</h3>
            <p style={{ marginBottom: '3.5rem' }}>Our talented team of developers have a proven track record of developing and deploying high-performing, completely tailored web and web app solutions that are flexible, scalable, and at competitive rates. We offer;</p>
            <ul style={{ listStyleType: 'square' }}>
              <li>Flexible and timely development approach</li>
              <li>Highly qualified developers</li>
              <li>Competitive rates</li>
              <li>Smart coding strategies</li>
              <li>Varied industry expertise and cost-effective.</li>
            </ul>
          </div>
          <div className='thirdy_container_for_services'>
            <img src={`${process.env.PUBLIC_URL}/images/banner/5d4eb576e86e100608ebe6b4bf233f47db96fda1-581x552.jpg`} />
          </div>
        </div>
      </main>
      <CustomFooter />
    </>
  )
}

export default AngularJSDevelopment